jQuery( document ).ready(function() {
    let $ = jQuery;

    if( $('section.news-gallery').length ) {
        $('section.news-gallery').each( function() {
            var $status = $(this).find('.slide-count');
            var $slickElement = $(this).find('.image-container .slider');

            $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $status.html(i + '<span>/</span> ' + slick.slideCount);
            });

            $($slickElement).slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                rows: 0,
                speed: 1000,
            });

            $($slickElement).on('beforeChange', function(event, slick, currentSlide, nextSlide){
                var slides = $($slickElement).slick("getSlick").$slides;
                var bg = slides.eq( nextSlide ).data("bg");
                $('body .navigation').attr('data-color', bg);
            });
        });


    }
});